export default __webpack_public_path__ + "static/media/logo-ecert-azul.193b7e41.svg";